import { useEffect } from "react";

function WriteReviewTastic(props) {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://ui.powerreviews.com/stable/4.1/ui.js";
        script.async = true;

        script.onload = () => {
            window.pwr =
                window.pwr ||
                function () {
                    (window.pwr.q = window.pwr.q || []).push(arguments);
                };

            window.pwr("render", {
                api_key: process.env.NEXT_PUBLIC_POWER_REVIEW_API_KEY,
                locale: "en_US",
                merchant_group_id:
                    process.env.NEXT_PUBLIC_POWER_REVIEW_MERCHANT_GROUP_ID,
                merchant_id:
                    process.env.NEXT_PUBLIC_POWER_REVIEW_MERCHANT_ID,

                components: {
                    Write: "pr-write",
                },
            });
        };

        document.body.appendChild(script);
    }, []);

    return <div id="pr-write" className="pr-write-custom-styles"></div>;
}

export default WriteReviewTastic;
